import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_LOCATIONS_STATUS_FLAGS_MUTATION } from '../graphql/mutations'
import { UPDATE_LOCATION_STATUS_FLAG } from '../redux/action-types'

const useUpdateLocationsStatusFlagsMutation = fieldName => {
  const dispatch = useDispatch()

  const mutate = useCallback(
    (ids, value) =>
      apolloService.mutate({
        mutation: UPDATE_LOCATIONS_STATUS_FLAGS_MUTATION,
        variables: { ids, data: { [fieldName]: value } },
        dispatch,
        action: UPDATE_LOCATION_STATUS_FLAG,
      }),
    [dispatch, fieldName],
  )

  return [mutate]
}

export default useUpdateLocationsStatusFlagsMutation
